import { QueryConfig } from "store/utils/query-config";

export const companiesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdTime"]
  }
};
